<template lang="pug">
b-container(fluid)
    //p Coming soon
    div(id="dynamic_properties")
</template>

<script>
import axios from 'axios'
import router from '../router'
import * as d3 from 'd3'

const apiBaseUrl = '/scop3ptm/api/'
export default {
    name: 'DynaminePredictions',
    data: function() {
        return {
            dp: [],
            xScale: function() {},
            yScale: function() {},
            xAxis: '',
            chart_height: '',
            chart_width: '',
            zoom: '',
            svg: '',
            svg2: '',
            proteinseq: '',
            seqarray: [],
            idleTimeout: null,
            keys: ["backboneDynamics", "disorderedPropensity", "earlyFolding"]
        }
    },
    created: function() {
        if (this.$store.state.proteinId == null) {
            this.getProtein()
        }
    },
    mounted: function() {
        this.getDynaminePredictions()
        // this.renderView()
    },
    methods: {
        renderView: function() {
            this.initProteinBlock()
            this.renderProteinSeq()
        },
        initProteinBlock() {
            const color = ['lightgreen', 'lightblue', 'lightred']
            let margin = { top: 10, right: 30, bottom: 30, left: 60 },
                svg_width = document.getElementById('dynamic_properties').offsetWidth,
                svg_height = 500
            this.chart_height = svg_height - margin.top - margin.bottom
            this.chart_width = svg_width - margin.left - margin.right - 200
            let moveXaxis = 0
            let xMax = this.dp.length,
                xMin = 1
            this.xScale = d3
                .scaleLinear()
                .range([0, this.chart_width])
                .nice()
                .domain([xMin, xMax])
            this.xAxis = d3.axisBottom(this.xScale)
            this.yScale = d3.scaleLinear()
                .range([this.chart_height, 0])
                .domain([0, 1])

            // this.zoom = d3
            //     .zoom()
            //     .scaleExtent([1, (4 / 120) * this.dp.length]) //1,50
            //     .translateExtent([
            //         [0, 0],
            //         [this.chart_width, this.chart_height]
            //     ])
            //     .on('zoom', this.zoomed)
            this.svg = d3.select('#dynamic_properties')
                .append('svg')
                .attr('width', this.chart_width + margin.left + margin.right)
                .attr('height', this.chart_height + margin.top + margin.bottom)
                .attr('class', 'dynamic')
                .append('g')
                .attr('transform','translate(' + margin.left + ',' + margin.top + ')');
            this.svg2 = this.svg
                .append('svg')
                .attr('width', this.chart_width)
                .attr('height', this.chart_height)
                .append('g')
            //     .call(this.zoom)
            let view = this.svg2
                .append('rect')
                .attr('width', this.chart_width)
                .attr('height', this.chart_height)
                .style('fill', 'white')

            let gX = this.svg
                .append('g')
                .classed('xAxis', true)
                .attr(
                    'transform',
                    'translate(0,' + (this.chart_height + moveXaxis) + ')'
                )
                .call(this.xAxis)
            this.svg
                .append('g')
                .attr('transform', `translate(0, 0)`)
                .call(d3.axisLeft(this.yScale))

            let xAxisLabel = this.svg
                .append('text')
                .attr('class', 'x label')
                .attr('text-anchor', 'middle')
                .attr('x', this.chart_width / 2)
                .attr('y', this.chart_height + 30)
                .text('Protein Sequence')
                .style('font-size', '13px')
                .style('font-family', 'Arial')
            const clip = this.svg.append('defs').append('svg:clipPath')
                .attr('id', 'clip')
                .append('svg:rect')
                .attr('width', this.chart_width)
                .attr('height', this.chart_height)
                .attr('x', 0)
                .attr('y', 0)

            // Add brushing
            const brush = d3.brushX() // Add the brush feature using the d3.brush function
                .extent([
                    [0,0],
                    [this.chart_width, this.chart_height]
                ]) // initialise the brush area: start at 0,0 and finishes at width,height: it means I select the whole graph area
                .on('end', this.updateChart)
            const keys = ['backboneDynamics', 'disorderedPropensity', 'earlyFolding']
            const sources = keys.map((k, i) => {
                return {
                    id: k,
                    values: this.dp.map((el, index) => {
                        return {
                            position: el.position,
                            yPos: el[k]
                        }
                    })
                }
            })
            const colour = d3.scaleOrdinal()
                .domain(keys)
                .range(d3.schemeSet2)
            let areaChart = this.svg2.append('g')
                .attr('clip-path', 'url(#clip)')
            const area = d3.area()
                .x(dataPoint => { 
                    return this.xScale(dataPoint.position)
                })
                .y0(dataPoint => {
                    return this.yScale(0)
                })
                .y1(dataPoint => {return this.yScale(dataPoint.yPos)})
            areaChart.selectAll('mylayers')
                .data(sources)
                .enter()
                .append('path')
                .attr('class', d => {return 'myArea ' + d.id})
                .style('fill', d => {return colour(d.id)})
                .attr('d', d => {return area(d.values)})
            const highlight = d => {
                console.log('highlight', d)
                // reduce opacity of all groups
                d3.selectAll(".myArea").style("opacity", .2)
                // expect the one that is hovered
                d3.select("."+d).style("opacity", 0.8)
            }

            // And when it is not hovered anymore
            const noHighlight = d => {
                d3.selectAll(".myArea").style("opacity", 1)
            }
            const size = 20
            this.svg.selectAll("myrect")
                .data(keys)
                .enter()
                .append("rect")
                .attr("x", this.chart_width)
                .attr("y", function(d,i){ return 10 + i*(size+5)}) // 100 is where the first dot appears. 25 is the distance between dots
                .attr("width", size)
                .attr("height", size)
                .style("fill", function(d){
                    return colour(d)
                })
                .on("mouseover", (event, d) => {
                    return highlight(d)
                })
                .on("mouseleave", noHighlight)

            // Add one dot in the legend for each name.
            this.svg.selectAll("mylabels")
                .data(keys)
                .enter()
                .append("text")
                .attr("x", this.chart_width + size*1.2)
                .attr("y", function(d,i){ return 10 + i*(size+5) + (size/2)}) // 100 is where the first dot appears. 25 is the distance between dots
                .style("fill", function(d){ return colour(d)})
                .text(function(d){ return d})
                .attr("text-anchor", "left")
                .style("alignment-baseline", "middle")
                .on("mouseover", (event, d) => {
                    return highlight(d)
                })
                .on("mouseleave", noHighlight)
        },
        idled() { this.idleTimeout = null; },
        // A function that update the chart for given boundaries
        updateChart(event) {
            console.log(event)
            const extent = event.selection
            // If no selection, back to initial coordinate. Otherwise, update X axis domain
            if(!extent) {
                if (!this.idleTimeout) return this.idleTimeout = setTimeout(this.idled, 350); // This allows to wait a little bit
                this.xAxis.domain(d3.extent(this.sources, d => { 
                    console.log(d) 
                    return d.position; }
                ))
            } else {
                this.xAxis.domain([ this.xAxis.invert(extent[0]), this.xAxis.invert(extent[1]) ])
                this.areaChart.select('.brush').call(this.brush.move, null) // This remove the grey brush area as soon as the selection has been done
            }

            // Update axis and area position
            this.xAxis.transition().duration(1000).call(d3.axisBottom(this.xAxis).ticks(5))
            this.areaChart
                .selectAll('path')
                .transition().duration(1000)
                .attr('d', d => {
                    return this.area(d.values)
                })
        },
        renderProteinSeq() {
            this.proteinseq = this.svg2
                .append('g')
                .selectAll('text')
                .data(this.seqarray)
                .enter()
                .append('text')
                .attr('y', this.chart_height - 2)
                .text(function(d) {
                    return d
                })
                .attr('x', (d, i) => this.xScale(i + 1))
                .style('font-size', '13px')
                .style('x', '5')
                .attr('text-anchor', 'middle')
                .attr('visibility', 'hidden')
        },
        async getDynaminePredictions() {
            const dpUrl = apiBaseUrl + 'get-dynamine-predictions'
            const response = await axios
                .get(dpUrl, {
                    params: {
                        protein_id: this.$store.state.proteinId
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            this.dp = response.data.dynaminePredictions
            this.dp.forEach(el => {
                this.seqarray.push(el.residue)
            })
            this.renderView()
        }
    }
}
</script>

<style lang="scss">
@import '../assets/scss/variables';
.dynamic {
    overflow: unset;
}
</style>